import Case from 'case';
import {currentScript} from './constants';

const
  NO                  = 'no',
  EMPTY               = '',
  OTHERS              = 'otros',
  ANONYMOUS           = 'anonimo',
  ZERO                = 0,
  ONE                 = 1,
  TWO                 = 2,
  AUT                 = 'aut',
  ES                  = 'es',
  WEB_CONTENT         = 'contenido-web',
  M_RESPONSIVE        = 'm-responsive',
  METHODE             = 'methode',
  _params             = {},
  _query              = {},
  _userType           = window.__VOONTO__.getUserType(),
  _krux               = currentScript.getAttribute('data-legacy-krux'),
  _site               = window.__VOONTO__.lookup('vocento.site'),
  _editions           = window.__VOONTO__.lookup('vocento.site.editions'),
  {Cookies, parseUrl, is} = window,
  _vocUid  = decodeURIComponent(Cookies.get('voc_uid'))
;

var _urlParts = window.location.pathname.substring(1).split('/');

if (_hasSubdomain()) {_urlParts = [_site.subdomain || ''].concat(_urlParts);}

window.location.hash.substring(1).split('&').forEach((pair) => {
  _params[pair.split('=').shift()] = pair.split('=').pop();
});

window.location.search.substring(1).split('&').forEach((pair) => {
  _query[pair.split('=').shift()] = pair.split('=').pop();
});

window.customService = window.customService || window.__VOONTO__.lookup('vocento.site').media;

export function serialize(str) {
  return Case.kebab(str);
}

export function defaults() {
  if (!window.voc_se) {window.voc_tc = OTHERS;}
  window.voc_top && (window.voc_top = window.voc_top.replace(/;/g, ','));

  window.voc_usrid = _vocUid === 'undefined' ? undefined : JSON.parse(_vocUid).uid;

  return {
    scrollInfinito:             _query.vtm_scrollInfinito            || _params.vtm_scrollInfinito            || false,
    seccion:                    _query.vtm_seccion                   || _params.vtm_seccion                   || window.voc_se || _getValueAtIndex(_urlParts, 0)   || EMPTY,
    subseccion1:                _query.vtm_subseccion1               || _params.vtm_subseccion1               || window.voc_s1 || (!window.voc_se ? _getValueAtIndex(_urlParts, 1) : EMPTY) || EMPTY,
    subseccion2:                _query.vtm_subseccion2               || _params.vtm_subseccion2               || window.voc_s2 || (!window.voc_se ? _getValueAtIndex(_urlParts, 2) : EMPTY) || EMPTY,
    subseccion3:                _query.vtm_subseccion3               || _params.vtm_subseccion3               || window.voc_s3 || (!window.voc_se ? _getValueAtIndex(_urlParts, 3) : EMPTY) || EMPTY,
    subseccion4:                _query.vtm_subseccion4               || _params.vtm_subseccion4               || (!window.voc_s3 ? EMPTY : (window.voc_s4 || (!window.voc_se ? _getValueAtIndex(_urlParts, 4) : EMPTY))) || EMPTY,
    titular:                    _query.vtm_titular                   || _params.vtm_titular                   || window.voc_tn                                     || document.title,
    errorPagina:                _query.vtm_errorPagina               || _params.vtm_errorPagina                                                                    || EMPTY,
    tipoDominio:                _query.vtm_tipoDominio               || _params.vtm_tipoDominio               || window.voc_pr                                     || EMPTY,
    edicion:                    _query.vtm_edicion                   || _params.vtm_edicion                   || window.voc_ed || _editions.current                || EMPTY,
    tipoContenido:              _query.vtm_tipoContenido             || _params.vtm_tipoContenido             || window.voc_tc                                     || EMPTY,
    tipoContenidoA:             _query.vtm_tipoContenidoA            || _params.vtm_tipoContenidoA            || window.voc_tcnew                                  || EMPTY,
    contenidoPremium:           _query.vtm_contenidoPremium          || _params.vtm_contenidoPremium                                                               || NO,
    plataformaContenido:        _query.vtm_plataformaContenido       || _params.vtm_plataformaContenido       || window.voc_pl || _getPlataformaContenido()        || WEB_CONTENT,
    sistemaPublicacion:         _query.vtm_sistemaPublicacion        || _params.vtm_sistemaPublicacion        || window.voc_pu                                     || METHODE,
    fechaPrimeraPublicacion:    _query.vtm_fechaPrimeraPublicacion   || _params.vtm_fechaPrimeraPublicacion   || window.voc_fep                                    || EMPTY,
    fechaModificacion:          _query.vtm_fechaModificacion         || _params.vtm_fechaModificacion         || window.voc_fem                                    || EMPTY,
    movilidad:                  _query.vtm_movilidad                 || _params.vtm_movilidad                 || window.voc_adp || (Cookies.get('voc_mobile') ? TWO : EMPTY),
    hiperlocalSeccion:          _query.vtm_hiperlocalSeccion         || _params.vtm_hiperlocalSeccion                                                              || EMPTY,
    hiperlocalEdicionEspecial:  _query.vtm_hiperlocalEdicionEspecial || _params.vtm_hiperlocalEdicionEspecial                                                      || NO,
    contenidoDestacado:         _query.vtm_contenidoDestacado        || _params.vtm_contenidoDestacado                                                             || NO,
    origenPortada:              _query.vtm_origenPortada             || _params.vtm_origenPortada             || window.voc_ho || (_isHomeReferrer() ? ONE : ZERO) || ZERO,
    loMas:                      _query.vtm_loMas                     || _params.vtm_loMas                                                                          || NO,
    idioma:                     _query.vtm_idioma                    || _params.vtm_idioma                    || window.voc_idi                                    || ES,
    tipologiaLogin:             _query.vtm_tipologiaLogin            || _params.vtm_tipologiaLogin            || window.voc_tusr || _userType                      || ANONYMOUS,
    IDKrux:                     _query.vtm_IDKrux                    || _params.vtm_IDKrux                    || window.voc_krux || _krux                          || EMPTY,
    IDGigya:                    _query.vtm_IDGigya                   || _params.vtm_IDGigya                   || window.voc_usrid                                  || EMPTY,
    edad:                       _query.vtm_edad                      || _params.vtm_edad                      || window.voc_usrag                                  || EMPTY,
    codigoPostal:               _query.vtm_codigoPostal              || _params.vtm_codigoPostal              || window.voc_usrcp                                  || EMPTY,
    genero:                     _query.vtm_genero                    || _params.vtm_genero                    || window.voc_usrgen                                 || EMPTY,
    rutaNavegacion:             _query.vtm_rutaNavegacion            || _params.vtm_rutaNavegacion                                                                 || EMPTY,
    sitioRegistro:              _query.vtm_sitioRegistro             || _params.vtm_sitioRegistro             || window.customService                              || EMPTY,
    IDEvolok:                   _query.vtm_IDEvolok                  || _params.vtm_IDEvolok                  || window.voc_pw_pid                                 || EMPTY,
    productoEvolok:             _query.vtm_productoEvolok            || _params.vtm_productoEvolok            || window.voc_pw_meter                               || EMPTY,
    nPaginasConsumidas:         _query.vtm_nPaginasConsumidas        || _params.vtm_nPaginasConsumidas        || window.voc_pw_count                               || EMPTY,
    nPaginasPermitidas:         _query.vtm_nPaginasPermitidas        || _params.vtm_nPaginasPermitidas        || window.voc_pw_max                                 || EMPTY,
    autorizacionContenido:      _query.vtm_autorizacionContenido     || _params.vtm_autorizacionContenido     || window.voc_pw_result                              || EMPTY,
    idCookieEvolok:             _query.vtm_idCookieEvolok            || _params.vtm_idCookieEvolok            || window.voc_pw_cookie || Cookies.get('ev_sid')     || EMPTY,
    IDPedido:                   _query.vtm_IDPedido                  || _params.vtm_IDPedido                                                                       || EMPTY,
    SKU:                        _query.vtm_SKU                       || _params.vtm_SKU                                                                            || EMPTY,
    nombreProducto:             _query.vtm_nombreProducto            || _params.vtm_nombreProducto                                                                 || EMPTY,
    categoriaProducto:          _query.vtm_categoriaProducto         || _params.vtm_categoriaProducto                                                              || EMPTY,
    unidadesProducto:           _query.vtm_unidadesProducto          || _params.vtm_unidadesProducto                                                               || EMPTY,
    precio:                     _query.vtm_precio                    || _params.vtm_precio                                                                         || EMPTY,
    nombreTienda:               _query.vtm_nombreTienda              || _params.vtm_nombreTienda                                                                   || EMPTY,
    accionEcommerce:            _query.vtm_accionEcommerce           || _params.vtm_accionEcommerce                                                                || EMPTY,
    impuestos:                  _query.vtm_impuestos                 || _params.vtm_impuestos                                                                      || EMPTY,
    gastosEnvio:                _query.vtm_gastosEnvio               || _params.vtm_gastosEnvio                                                                    || EMPTY,
    precioTotal:                _query.vtm_precioTotal               || _params.vtm_precioTotal                                                                    || EMPTY,
    fechaRegistroEcommerce:     _query.vtm_fechaRegistroEcommerce    || _params.vtm_fechaRegistroEcommerce                                                         || EMPTY,
    CSsubchannel:               _query.vtm_CSsubchannel              || _params.vtm_CSsubchannel                                                                   || EMPTY,
    CSgrupo:                    _query.vtm_CSgrupo                   || _params.vtm_CSgrupo                                                                        || EMPTY,
    CSsubgrupo:                 _query.vtm_CSsubgrupo                || _params.vtm_CSsubgrupo                                                                     || EMPTY,
    adBlockers:                 _query.vtm_adBlockers                || _params.vtm_adBlockers                || window.voc_adb                                    || ZERO,
    capasMostradas:             _query.vtm_capasMostradas            || _params.vtm_capasMostradas                                                                 || EMPTY,
    origenTags:                 _query.vtm_origenTags                || _params.vtm_origenTags                                                                     || NO,
    firmaAutor:                 _query.vtm_firmaAutor                || _params.vtm_firmaAutor                || window.voc_au                                     || EMPTY,
    fichaAutor:                 _query.vtm_fichaAutor                || _params.vtm_fichaAutor                || (window.voc_or === AUT ? (window.id_autor || window.voc_s1) : EMPTY),
    origenContenido:            _query.vtm_origenContenido           || _params.vtm_origenContenido           || window.voc_or                                     || EMPTY,
    topics:                     _query.vtm_topics                    || _params.vtm_topics                    || window.voc_top                                    || EMPTY,
    proceso:                    _query.vtm_proceso                   || _params.vtm_proceso                                                                        || EMPTY,
    funnel:                     _query.vtm_funnel                    || _params.vtm_funnel                                                                         || EMPTY,
    paso:                       _query.vtm_paso                      || _params.vtm_paso                                                                           || EMPTY,
    procesoFinalizado:          _query.vtm_procesoFinalizado         || _params.vtm_procesoFinalizado                                                              || EMPTY,
    errorRechazo:               _query.vtm_errorRechazo              || _params.vtm_errorRechazo                                                                   || EMPTY,
    procesoEstatus:             _query.vtm_procesoEstatus            || _params.vtm_procesoEstatus                                                                 || EMPTY,
    tipoRegistroLogin:          _query.vtm_tipoRegistroLogin         || _params.vtm_tipoRegistroLogin                                                              || EMPTY,
    tipoBuscador:               _query.vtm_tipoBuscador              || _params.vtm_tipoBuscador                                                                   || EMPTY,
    keyword:                    _query.vtm_keyword                   || _params.vtm_keyword                                                                        || EMPTY,
    nResultados:                _query.vtm_nResultados               || _params.vtm_nResultados                                                                    || EMPTY,
    errorBusqueda:              _query.vtm_errorBusqueda             || _params.vtm_errorBusqueda                                                                  || EMPTY,
    medioCampana:               _query.vtm_medioCampana              || _params.vtm_medioCampana              || _params.ns_mchannel || _query.ns_mchannel         || EMPTY,
    origenCampana:              _query.vtm_origenCampana             || _params.vtm_origenCampana             || _params.ns_source   || _query.ns_source           || EMPTY,
    sitioCampana:               _query.vtm_sitioCampana              || _params.vtm_sitioCampana                                                                   || EMPTY,
    localizacion:               _query.vtm_localizacion              || _params.vtm_localizacion                                                                   || EMPTY,
    idCampana:                  _query.vtm_idCampana                 || _params.vtm_idCampana                 || _params.ns_campaign || _query.ns_campaign         || EMPTY,
    seccionContenidoCampana:    _query.vtm_seccionContenidoCampana   || _params.vtm_seccionContenidoCampana   || _params.ns_linkname || _query.ns_linkname         || EMPTY,
    precioAsociadoCampana:      _query.vtm_precioAsociadoCampana     || _params.vtm_precioAsociadoCampana     || _params.ns_fee      || _query.ns_fee              || EMPTY,
    tipoCampana:                _query.vtm_tipoCampana               || _params.vtm_tipoCampana                                                                    || EMPTY,
    campanaPago:                _query.vtm_campanaPagp               || _params.vtm_campanaPagp                                                                    || EMPTY,
    contenidoEmbebido:          _query.vtm_contenidoEmbebido         || _params.vtm_contenidoEmbebido                                                              || NO,
    swipeScreen:                _query.vtm_swipeScreen               || _params.vtm_swipeScreen                                                                    || EMPTY,
    slot:                       _query.vtm_slot                      || _params.vtm_slot                                                                           || EMPTY
  };
}

export const properties = [
  'scrollInfinito',
  'seccion',
  'subseccion1',
  'subseccion2',
  'subseccion3',
  'subseccion4',
  'titular',
  'errorPagina',
  'tipoDominio',
  'edicion',
  'tipoContenido',
  'tipoContenidoA',
  'contenidoPremium',
  'plataformaContenido',
  'sistemaPublicacion',
  'fechaPrimeraPublicacion',
  'fechaModificacion',
  'movilidad',
  'hiperlocalSeccion',
  'hiperlocalEdicionEspecial',
  'contenidoDestacado',
  'origenPortada',
  'loMas',
  'idioma',
  'tipologiaLogin',
  'IDKrux',
  'IDGigya',
  'edad',
  'codigoPostal',
  'genero',
  'rutaNavegacion',
  'sitioRegistro',
  'IDEvolok',
  'productoEvolok',
  'nPaginasConsumidas',
  'nPaginasPermitidas',
  'autorizacionContenido',
  'idCookieEvolok',
  'IDPedido',
  'SKU',
  'nombreProducto',
  'categoriaProducto',
  'unidadesProducto',
  'precio',
  'nombreTienda',
  'accionEcommerce',
  'impuestos',
  'gastosEnvio',
  'precioTotal',
  'fechaRegistroEcommerce',
  'CSsubchannel',
  'CSgrupo',
  'CSsubgrupo',
  'adBlockers',
  'capasMostradas',
  'origenTags',
  'firmaAutor',
  'fichaAutor',
  'origenContenido',
  'topics',
  'proceso',
  'funnel',
  'paso',
  'procesoFinalizado',
  'errorRechazo',
  'procesoEstatus',
  'tipoRegistroLogin',
  'tipoBuscador',
  'keyword',
  'nResultados',
  'errorBusqueda',
  'medioCampana',
  'origenCampana',
  'sitioCampana',
  'localizacion',
  'idCampana',
  'seccionContenidoCampana',
  'precioAsociadoCampana',
  'tipoCampana',
  'campanaPago',
  'contenidoEmbebido',
  'swipeScreen',
  'slot'
];

export const excludeSerialize = [
  'IDEvolok',
  'productoEvolok',
  'nPaginasConsumidas',
  'nPaginasPermitidas',
  'autorizacionContenido',
  'idCookieEvolok'
];

export default properties;

/* Private */

function _getValueAtIndex(arr, index) {
  console.log(arr, index);

  if (index > arr.length - 1) {return undefined;}
  if (arr.length && arr.length > index &&
     (~arr[index].indexOf('.asp') ||
      ~arr[index].indexOf('.php')  ||
      ~arr[index].indexOf('.html') ||
      ~arr[index].indexOf('.htm'))) {return undefined;}

  if (!index && !arr[index]) {return 'portada';}

  return arr[index];
}

function _isHomeReferrer() {
  var referrer = parseUrl(document.referrer);

  return referrer.resource === document.location.hostname &&
    (referrer.pathname === '/' ||
     referrer.pathname === '/index.asp' ||
     referrer.pathname === '/index.php' ||
     referrer.pathname === '/index.htm' ||
     referrer.pathname === '/index.html'
    );
}

function _getPlataformaContenido() {
  switch (true) {
    case is.desktop():
      return WEB_CONTENT;
    case is.mobile() || is.tablet():
      return M_RESPONSIVE;
  }
}

function _hasSubdomain() {
  return !/.*www$/.test(_site.subdomain);
}



// WEBPACK FOOTER //
// ./src/data-layer.js